import Details from '@/components/Details/Details';
import Tip from '@/components/Tip/Tip';
import IEventType from '@/types/IEventType';
import { Box, Button, Flex, Grid, Input, Switch, Text, Tooltip } from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa';
import { FcQuestions } from 'react-icons/fc';
import Question from './components/Question';
import useSectionQuestions from './useSectionQuestions';
export interface ISectionQuestionsProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function SectionQuestions(props: ISectionQuestionsProps) {
	const {
		handlePrivacyEnabledChange,
		handleQuestionChange,
		handleAddQuestionClick,
		handleDeleteClick,
		handlePrivacyBlur,
		t,
		privacyForm,
		isLoading,
	} = useSectionQuestions({
		service: props.service,
		onChange: props.onChange,
		questions: props.service.questions,
	});

	return (
		<Details image={<FcQuestions />} title={t('Questions')}>
			<Tip>{t('Add questions to get additional data from the person making the reservation.')}</Tip>

			<Flex justifyContent="flex-end" mb={4}>
				<Button
					mt={2}
					size="sm"
					rightIcon={<FaPlus />}
					isLoading={isLoading}
					colorScheme="primary"
					onClick={handleAddQuestionClick}
				>
					{t('Add question')}
				</Button>
			</Flex>

			{props.service.questions.map((q) => (
				<Question
					key={q.id}
					{...q}
					isLoading={isLoading}
					onChange={handleQuestionChange}
					onDelete={handleDeleteClick}
				/>
			))}

			<Box p={4} borderColor="gray.200" borderRadius="md" borderWidth={1}>
				<Grid gridTemplateRows="auto auto">
					<Grid gridTemplateColumns="1fr auto">
						<Tooltip
							hasArrow
							label={t(
								'Enable this option to display a GDPR check. This ensures legal compliance but can reduce the number of bookings.'
							)}
						>
							<Text>{t('Privacy & terms')}</Text>
						</Tooltip>

						<Switch
							isDisabled={isLoading}
							isChecked={privacyForm.watch('isEnabled')}
							{...privacyForm.register('isEnabled')}
							onChange={handlePrivacyEnabledChange}
						/>
					</Grid>
					<Input
						isDisabled={isLoading}
						placeholder={t('Enter the link to your privacy policy.')}
						type="url"
						mt={2}
						display={privacyForm.watch('isEnabled') ? 'block' : 'none'}
						{...privacyForm.register('privacyLink')}
						onBlur={handlePrivacyBlur}
					/>
				</Grid>
			</Box>
		</Details>
	);
}
